export default "__VITE_ASSET__FKyKy$Jp__"